import React, { useState, useEffect, createContext, useContext } from "react";
import io from "socket.io-client";
import {
  getCompanyProfileGlobalData,
  updateCompanyHostURL,
} from "../app/services/setup/company-profile/companyProfileService";
import { Settings } from "luxon";
import { commUrl } from "../config"
const GlobalDataContext = createContext();

function GlobalDataProvider({ children }) {
  const socket = io(commUrl, {
    withCredentials: false,
    //transports: ["websocket"],
    //pingInterval: 1000 * 60 * 5,
    //pingTimeout: 1000 * 60 * 3,
    //allowUpgrades: false,
    //pingInterval: 25000,
    //pingTimeout: 180000,
    //autoConnect: true,
  });
  const [reload, setReload] = useState(0);
  const [companyProfile, setCompanyProfile] = useState({
    ID: 0,
    appCode: "",
    approvalLvl: 0,
    licenseKey: "",
    globalCustomerID: 0,
    globalCustomerLevel: 0,
    globalCustomerDeploymentType: 0,
    globalCustomerBillingType: 0,
    companyName: "",
    phone: "",
    email: "",
    website: "",
    taxpayerID: "",
    currencyID: 0,
    currencyCode: "",
    fullAddress: "",
    address: "",
    city: "",
    province: "",
    countryCode: "ID",
    postalCode: "",
    companyProfileThemes: [],
    companyProfileLogo: [],
  });
  const [companyProfileTheme, setCompanyProfileTheme] = useState({});
  const [invifoThemes, setInvifoThemes] = useState([]);
  const [companyThemes, setCompanyThemes] = useState([]);
  const [userPreferences, setUserPreferences] = useState({
    ID: 0,
    lightAsideSkin: true,
    darkAsideSkin: false,
    lightText: true,
    darkText: false,
    invifoThemeID: 0,
    customThemeID: 0,
    language: "en",
    menuLayout: "Grid Large Square",
    invifoTheme: {},
    customTheme: {},
  });
  const [currentFiscalYear, setCurrentFiscalYear] = useState({});
  const [currentFiscalPeriod, setCurrentFiscalPeriod] = useState({});
  const [user, setUser] = useState({
    ID: 0,
    firstName: "",
    lastName: "",
    fullName: "",
    email: "",
    phone: "",
    username: "",
    groupID: 0,
    groupName: "",
    authID: 0,
    authName: "",
    userGroup: {
      groupName: "",
    },
    authorization: {
      authName: "",
    },
    userImage: [],
  });
  const [totalNotification, setTotalNotification] = useState(0);
  useEffect(() => {
    getCompanyProfileGlobalVariable();
    socket.on("connect", () => {
      //socket.emit("greet", "Hello Mr.Server!");
    });
    return () => {
      socket.off("connect");
    };
  }, [reload]);
  return (
    <GlobalDataContext.Provider
      value={{
        reload,
        setReload,
        socket,
        companyProfile,
        setCompanyProfile,
        companyProfileTheme,
        setCompanyProfileTheme,
        invifoThemes,
        setInvifoThemes,
        companyThemes,
        setCompanyThemes,
        userPreferences,
        setUserPreferences,
        currentFiscalYear,
        setCurrentFiscalYear,
        currentFiscalPeriod,
        setCurrentFiscalPeriod,
        user,
        setUser,
        totalNotification,
        setTotalNotification,
      }}
    >
      {companyProfile.ID > 0 ? (
        <React.Fragment>{children}</React.Fragment>
      ) : null}
    </GlobalDataContext.Provider>
  );

  async function getCompanyProfileGlobalVariable() {
    getCompanyProfileGlobalData().then((response) => {
      const { data } = response.data;
      Settings.defaultZoneName = data.companyProfile.timezone;
      setCompanyProfile(data.companyProfile);
      setCompanyProfileTheme(data.companyProfileTheme);
      setInvifoThemes(data.invifoThemes);
      setCompanyThemes(data.companyThemes);
      if (data.userPreferences.ID > 0) {
        setUserPreferences(data.userPreferences);
      } else {
        setUserPreferences({
          ID: 0,
          lightAsideSkin: true,
          darkAsideSkin: false,
          lightText: true,
          darkText: false,
          invifoThemeID: 0,
          customThemeID: 0,
          language: "en",
          menuLayout: "Grid Large Square",
          invifoTheme: {},
          customTheme: {},
        });
      }
      setCurrentFiscalYear(data.fiscalYear);
      setCurrentFiscalPeriod(data.fiscalPeriod);
      setUser(data.user);

      const origin = window.location.origin;
      const host = window.location.host;
      const hostname = window.location.hostname;
      const port = window.location.port;
      const protocol = window.location.protocol;
      if (
        data.companyProfile.origin !== origin ||
        data.companyProfile.host !== host ||
        data.companyProfile.hostname !== hostname ||
        data.companyProfile.port !== port ||
        data.companyProfile.protocol !== protocol
      ) {
        updateCompanyHostURL({
          origin: origin,
          host: host,
          hostname: hostname,
          port: port,
          protocol: protocol,
        });
      }
    });
  }
}

function useGlobalData() {
  return useContext(GlobalDataContext);
}

export { GlobalDataProvider, useGlobalData };
